export const PUBLIC_SEARCH_AGE_GROUPS = [
  { label: 'Age 18-25', ageGroup: '18-25' },
  { label: 'Age 26-30', ageGroup: '26-30' },
  { label: 'Age 31-35', ageGroup: '31-35' },
  { label: 'Age 36-40', ageGroup: '36-40' },
  { label: 'Age 41-45', ageGroup: '41-45' },
  { label: 'Age 46-50', ageGroup: '46-50' },
] as const;

export type PublicSearchAgeGroup = (typeof PUBLIC_SEARCH_AGE_GROUPS)[number]['ageGroup'];
export type PublicSearchGender = 'female' | 'male';

const AGE_GROUP_SET = new Set<string>(PUBLIC_SEARCH_AGE_GROUPS.map((option) => option.ageGroup));

export function isPublicSearchGender(value: string | null): value is PublicSearchGender {
  return value === 'female' || value === 'male';
}

export function isPublicSearchAgeGroup(value: string | null): value is PublicSearchAgeGroup {
  return value != null && AGE_GROUP_SET.has(value);
}

export function publicSearchPath(gender: PublicSearchGender, ageGroup: string): string {
  return `/search?gender=${gender}&ageGroup=${encodeURIComponent(ageGroup)}`;
}
